const FEEDBACK_BASE_MESSAGE_FALLBACK =
  "Thanks for your feedback — every response makes the next talk sharper.";

export function getFeedbackMessageOverride(): string | null {
  return process.env.NEXT_PUBLIC_FEEDBACK_BASE_MESSAGE?.trim() || null;
}

export function getFeedbackBaseMessage(): string {
  return getFeedbackMessageOverride() || FEEDBACK_BASE_MESSAGE_FALLBACK;
}
